import React, { useEffect } from "react";
import SpinnerUAU from "../../../../Components/Loding/SpinnerUAU";
import { VerificaInadimplenciaProdutoController } from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import {
    CarregarModelosRenegociacaoController,
    ValidaProdutoECasoParaRenegociacaoController,
} from "../../../../Controllers/Cobranca/Renegociacao/RenegociacaoControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IParcelas } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import RegistrarAcordo from "../RegistrarAcordo";

interface IRenegociacaoProps extends IParcelas {
    idCaso: number;
    idProduto: number;
    setShow: (show: boolean) => void;
}

export default function Renegociacao(props: IRenegociacaoProps) {
    const ValidaProdutoECasoParaRenegociacao = useAsyncCallback(
        ValidaProdutoECasoParaRenegociacaoController
    );
    const { execute: ValidaParaRenegociacao } =
        ValidaProdutoECasoParaRenegociacao;

    const VerificaInadimplenciaProduto = useAsyncEffect(() => {
        return VerificaInadimplenciaProdutoController(
            `${props.NR_EMPRESA}_${props.DS_OBRA}_${props.NR_VENDA}`
        );
    }, [props.NR_EMPRESA, props.DS_OBRA, props.NR_VENDA]);

    const CarregaModelosVendaReneg = useAsyncEffect(() => {
        return CarregarModelosRenegociacaoController(props.idCaso);
    }, [props.idCaso]);

    const erros = [] as string[];
    if (
        ValidaProdutoECasoParaRenegociacao.status === "success" &&
        ValidaProdutoECasoParaRenegociacao.value?.Continua === false
    )
        erros.push(ValidaProdutoECasoParaRenegociacao.value?.Mensagem);
    // if (
    //     VerificaInadimplenciaProduto.status === "success" &&
    //     !VerificaInadimplenciaProduto.value
    // )
    //     erros.push(
    //         "Não é possível realizar a renegociação pois o produto está adimplente"
    //     );
    if (
        CarregaModelosVendaReneg.status === "success" &&
        CarregaModelosVendaReneg.value &&
        CarregaModelosVendaReneg.value.length === 0
    )
        erros.push(
            "Você não têm acesso a nenhum modelo de venda para realizaar a renegociação!"
        );

    useEffect(() => {
        ValidaParaRenegociacao({
            ID_CASO: props.idCaso,
            ID_CHAVE_ERP: `${props.NR_EMPRESA}_${props.DS_OBRA}_${props.NR_VENDA}`,
        });
    }, [
        props.idCaso,
        props.NR_EMPRESA,
        props.DS_OBRA,
        props.NR_VENDA,
        ValidaParaRenegociacao,
    ]);

    return (
        <>
            {ValidaProdutoECasoParaRenegociacao.value &&
            VerificaInadimplenciaProduto.value !== undefined &&
            CarregaModelosVendaReneg.value !== undefined ? (
                erros.length === 0 ? (
                    <RegistrarAcordo
                        {...props}
                        lstModelos={CarregaModelosVendaReneg.value}
                    />
                ) : (
                    <div className="text-center text-danger font-size-h6">
                        {erros.map((erro) => (
                            <p key={erro}>{erro}</p>
                        ))}
                    </div>
                )
            ) : ValidaProdutoECasoParaRenegociacao.loading ||
              VerificaInadimplenciaProduto.loading ||
              CarregaModelosVendaReneg.loading ? (
                <SpinnerUAU />
            ) : (
                <div className="text-center text-muted">
                    Tivemos problemas para carregar os dados
                </div>
            )}
        </>
    );
}
